module.exports = __webpack_public_path__ + "img/nodejs.b337a2fb.svg";